import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
    Grid,
    Paper,
    Typography,
    ButtonGroup,
    Button,
    FormControl,
    MenuItem,
    TextField,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';

import {
    incrementEventPageIndex, decrementEventPageIndex,
    setEventsPerPage, eventPageIndexSelector, eventPageCountSelector,
    eventsPerPageSelector,
} from '../../features/events/eventsSlice';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 100,
    },
    selectEmpty: {
        marginTop: useTheme().spacing(2),
    },
}));

const perPageOptions = [10, 25, 50, 100];

const EventBarPaginate = () => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const eventPageIndex = useSelector(eventPageIndexSelector);
    const eventPageCount = useSelector(eventPageCountSelector);
    const eventsPerPage = useSelector(eventsPerPageSelector);

    const [perPage, setPerPage] = useState(25);

    useEffect(() => {
        setPerPage(eventsPerPage);
    }, [eventsPerPage]);

    const onPerPage = (e) => {
        //console.log("On page", e.target.value);
        setPerPage(e.target.value);
        dispatch(setEventsPerPage(e.target.value));
    }

    return (
        <div style={{ marginTop: '2px', marginBottom: '2px' }}>
            <Paper>
                <Grid
                    container
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    alignContent="center"
                    wrap='wrap'
                    spacing={1}
                    style={{
                        marginLeft: '5px',
                        marginBottom: '5px',
                    }}
                >
                    <Grid item sm={7}>
                        <ButtonGroup size="small">
                            <Button
                                startIcon={<FastRewindIcon color="primary" />}
                                onClick={() => dispatch(decrementEventPageIndex())}
                                disabled={eventPageIndex === 1}
                            />
                            <Button>
                                <Typography variant="body1" align="center">
                                    Page: {eventPageIndex}/{eventPageCount}
                                </Typography>
                            </Button>
                            <Button
                                endIcon={<FastForwardIcon color="primary" />}
                                onClick={() => dispatch(incrementEventPageIndex())}
                                disabled={eventPageIndex === eventPageCount}
                            />
                        </ButtonGroup>
                    </Grid>

                    <Grid item sm={5}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id="peiodTypeSelect"
                                select
                                value={perPage}
                                onChange={onPerPage}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">Per Page:</InputAdornment>,
                                }}
                            >
                                {
                                    perPageOptions.map(ev => <MenuItem key={ev} value={ev}>{ev}</MenuItem>)
                                }
                                <MenuItem key={"custom"} value={"custom"}>{"Custom"}</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
}

export default EventBarPaginate;